var React = require('react');

function IconPlayInline (props) {
    return React.createElement("path",props);
}

IconPlayInline.defaultProps = {"d":"m43.80323,26.98457l-36.37971,18.45031c-1.98491,1.00665 -4.46564,0.31615 -5.54081,-1.54235c-0.32378,-0.55971 -0.49335,-1.18617 -0.49335,-1.82273l0,-36.90054c0,-2.11361 1.82997,-3.82705 4.08741,-3.82705c0.67986,0 1.34897,0.15878 1.94676,0.46196l36.37971,18.45027c1.98495,1.00668 2.72244,3.32935 1.64726,5.18781c-0.37769,0.65285 -0.94999,1.1887 -1.64726,1.54232z"};

module.exports = IconPlayInline;

IconPlayInline.default = IconPlayInline;
